/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase'
import {  Container, Table, Rating, Header, Icon, Grid, Button, List } from 'semantic-ui-react'
// import { withProps } from "recompose"
import MapGL, { Marker, Popup, SVGOverlay, CanvasOverlay, LinearInterpolator, FlyToInterpolator } from 'react-map-gl';
// import d3 from 'd3-ease'
import { MAPBOX_TOKEN } from '../../../../config/tokens'
import { isAdmin } from '../../../../utils/admin'

// maybe i need this?
import {scaleOrdinal} from 'd3-scale';
import {schemeCategory10} from 'd3-scale-chromatic';
import {rgb} from 'd3-color';
import moment from 'moment'

// import dude, { bro } from '../../../utils/dude'


const windowAlert = window.alert;


function round(x, n) {
  const tenN = Math.pow(10, n);
  return Math.round(x * tenN) / tenN;
}

function getRGBA(color) {
  const {r,g,b,a} = color

  const rr = r > 0 ?  Math.floor(255*r) : 0
  const gg = g > 0 ?  Math.floor(255*g) : 0
  const bb = b > 0 ?  Math.floor(255*b) : 0

  if(rr > 255 || gg > 255 || bb > 255)
    return `rgba(${r}, ${g}, ${b}, ${a})`; // this is an error

  return `rgba(${rr}, ${gg}, ${bb}, ${a})`;
}



// ----------------------------------------------------------


const timeoutLength = 2500
/// breaking some shiht out!

class SessionPopupInfo extends Component {

  // state = { isOpen: false }
  //
  // handleOpen = () => {
  //   this.setState({ isOpen: true })
  //
  //   // this.timeout = setTimeout(() => {
  //   //   this.setState({ isOpen: false })
  //   // }, timeoutLength)
  // }
  //
  // handleClose = () => {
  //   this.setState({ isOpen: false })
  //   // clearTimeout(this.timeout)
  // }


  render() {

    // const { station } = this.props
    // console.log('PROPS',this.props)


      // console.log('_renderSessionMarker', station)
      const { coordinates, createdAt, lineCount, username, views, locale, otherSessionsByUser} = this.props.session;

      const popupContent = (
    <List>
    <List.Item>
      <List.Icon name='user' />
      <List.Content>{username}</List.Content>
    </List.Item>
    <List.Item>
      <List.Icon name='marker' />
      <List.Content>{moment(createdAt).fromNow()}</List.Content>
    </List.Item>
    </List>
    )

    return popupContent
      // return (
      //   <Marker key={Math.random()} longitude={coordinates[0]} latitude={coordinates[1]} >
      //   <Button circular className='marker-button'>
      //      <Popup
      //       trigger={<span aria-label='asdf' role='img'>🙂</span>}
      //       content={popupContent}
      //
      //
      //       size='mini'
      //
      //
      //       on='click'
      //       />
      //   </Button>
      //   </Marker>
      // );

  }
}


const ZoomButtons = ({mode, zoomIn, zoomOut}) => {


  // if(mode === 'discover')
    return (
      <div style={{position: 'absolute', bottom: 50, right: 50}}>
    <Button circular basic icon='zoom in' color='black' onClick={zoomIn} />
    <Button circular basic color='black' icon='zoom out' onClick={zoomOut} />
  </div>
    )
  // else
  // return null
}


class Map extends Component {

  state = {
    // shareWith: '',
    // loading: true,
    // dataLoaded: false,
    // visibleDrawings: [],
    viewport: {
      bearing: 0,
      // pitch: 50,
      pitch: 0,
      width: 800,
      height: 800,
      latitude: 0,
      longitude: 0,
      zoom: 14,
    },
    settings: {
      dragPan: true,
      dragRotate: true,
      scrollZoom: true,
      touchZoom: true,
      touchRotate: true,
      keyboard: true,
      doubleClickZoom: true,
      minZoom: 0,
      maxZoom: 20,
      minPitch: 0,
      maxPitch: 85
    },
    drawingLocations: [],
    userLocations: [],

    activeSessionMarker: null,
    visibleSessions: [],
    initialized: false,
    popupInfo: null,

  }

  componentDidMount() {
    // console.log('componentDidMount map')
    window.addEventListener('resize', this._resize);
    this._resize();
  }

  componentDidUpdate(prevProps) {

    // console.log('componentDidUpdate map')

    if(!this.state.initialized) {
      console.log('we live for first time, zoom to most recent')
      const tempSession = this.props.sessions[0]
      // for now, just set all sessions visible
      this.setState({
        visibleSessions: this.props.sessions,
        initialized: true,
        viewport: {
          ...this.state.viewport,
          latitude: tempSession.latitude,
          longitude: tempSession.longitude,
          zoom: 13,
        }
      })


      this._setDrawingData(tempSession)
      // this._moveToSpot(this.props.activeSession)
      // this._setDrawingData(this.props.activeSession)
    }


    if(prevProps.activeSession._key !== this.props.activeSession._key) {
      // then lets move!
      console.log('move map')
      this._moveToSpot(this.props.activeSession)

      this._setAllDrawingData(this.props.sessions)
    }

    // if(prevProps.zoom !== this.props.zoom) {
    //   // then lets zoom!
    //   console.log('zoom map')
    //   this.setState({
    //     viewport: {
    //       ...this.state.viewport,
    //       zoom: this.props.zoom,
    //     }
    //   })
    // }



  }



  _setAllDrawingData(sessions) {
    _.forEach(sessions, (session, key) => {
      // console.log('session',session)
      // console.log('key',key)
      this._setDrawingData(session)
    })
  }

  _setDrawingData(session) {
    // console.log('SESSION',session)
    let i = 0
    _.forEach(session.lines, (line, key) => {
      if(!session.l || typeof session.l[0] !== "number" ) { return }


      i++
      let routesLine = []
      let z = 0

      _.forEach(line.line, (dot, i) => {
        // if(z++ > 300) { return } // max
        if(z%10 !== 0) { return }

        const xPoint = Math.floor(line.line[i].x)

        const newLatOffset = 0.000004
        let newLat = session.l[1] + (newLatOffset * xPoint)

        const yPoint = Math.floor(line.line[i].y)

        const newLongOffset = 0.000008
        const gg = -0.007
        let newLong = session.l[0] + (newLongOffset * yPoint) + gg


        // also try to create a line
        routesLine.push([newLat,newLong])

      })

      let newDrawingLocation = {
        "coordinates" : routesLine,
        "strokeColor" : getRGBA(line.color),
        "sessionKey" : session._key,
        "lineKey" : key,
      }
      let drawingLocations = this.state.drawingLocations
      drawingLocations.push(newDrawingLocation)
      this.setState({drawingLocations})

    })

  }

  _getCoordsFromSession({l}) {
    return {
      latitude: l[0],
      longitude: l[1],
    }
  }

  _moveToSpot = (session) => {
    console.log(session)
    let zoom = this.state.viewport.zoom
    const coords = this._getCoordsFromSession(session)
    this.setState({
      // dataLoaded: true,
      viewport: {
        ...this.state.viewport,
        ...coords,
        zoom,
      }
    })
  }



    componentWillUnmount() {
      window.removeEventListener('resize', this._resize);
    }

    _resize = () => {
      this.setState({
        viewport: {
          ...this.state.viewport,
          width: window.innerWidth,
          height: window.innerHeight
        }
      });
    };

    _onViewportChange = viewport => {
      // console.log('v',viewport)
      this.setState({
        viewport: {
          ...viewport,
        },


      });
      // this.props.fetchViewport({
      //   ...viewport,
      // })
    }

    _prepareToDelete = (sessionKey, lineKey) => {
      window.open(`https://console.firebase.google.com/u/2/project/skywrite-5171c/database/skywrite-5171c/data/geoFire/${sessionKey}/lines/${lineKey}`);
    }

    _renderLine = (points, index, strokeColor, sessionKey, lineKey) => {
      let theStrokewidth = 4
      return (
        <g style={ {pointerEvents: 'click', cursor: 'pointer'} }>
          <g
            style={ {pointerEvents: 'visibleStroke'} }
            onClick={ () => this._prepareToDelete(sessionKey, lineKey) }>
            <path
              style={ {
                fill: 'none',
                // stroke: alphaify(color(index), 0.7),
                stroke: strokeColor,
                strokeWidth: theStrokewidth,
              } }
              d={ `M${points.join('L')}` }/>
          </g>
        </g>
      );
    }

    _redrawSVGOverlay = ({project}) => {
      // return null
      const { drawingLocations, viewport } = this.state

      if(viewport.zoom < 10)
        return null


      // console.log('c',this.mapGL)

      if(!this.mapGL)
        return

      const centerLat = this.state.viewport.latitude



      return (
        <g>
          {
            drawingLocations.map((drawing, index) => {
              // console.log('drawing.strokeColor',drawing.strokeColor)
              const points = drawing.coordinates.map(project).map(
                p => [round(p[0], 1), round(p[1], 1)]
              );
              // console.log('coordinates',drawing.coordinates)
              // console.log('center',centerLat)
              let distance = Math.abs(drawing.coordinates[0][1] - centerLat)
              // console.log('distance',distance)
              if(distance > 0.09) {return null}
              return <g key={ index }>{ this._renderLine(points, index, drawing.strokeColor, drawing.sessionKey, drawing.lineKey) }</g>;
            })
          }
        </g>
      );
    }

    _onSettingChange = (name, value) => this.setState({
      settings: {...this.state.settings, [name]: value}
    });


    _renderPopup() {
      const {popupInfo} = this.state;

      return popupInfo && (
        <Popup tipSize={20}
          anchor="bottom"

          longitude={popupInfo.longitude}
          latitude={popupInfo.latitude}
          onClose={() => this.setState({popupInfo: null})}


          >
          <SessionPopupInfo info={popupInfo} session={popupInfo}/>
        </Popup>
      );
    }

    _onMarkerClick = (session) => {
      this.props.onSessionClick(session)
      if(this.state.viewport.zoom < 12) {
        // this._moveToSpot(session)
        this._zoomIn(session)
      } else {
        this.setState({popupInfo: session})
      }



    }

    _renderSessionMarker = (session, index) => {
      return (
        <Marker key={`marker-${index}`}
          longitude={session.longitude}
          latitude={session.latitude} >
          <Button style={{padding: 2, }} circular onClick={() => this._onMarkerClick(session)} >
          <span aria-label='asdf' role='img'>🙂</span>
          </Button>

        </Marker>
      );
    }

    _zoomIn = ({latitude, longitude}) => {
      console.log('zi',longitude)
      this._onViewportChange({
        ...this.state.viewport,
        longitude: longitude || this.state.viewport.longitude,
        latitude: latitude || this.state.viewport.latitude,
        zoom: 15,
        transitionInterpolator: new FlyToInterpolator(),
        transitionDuration: 1000
    });
    }

    _zoomOut = () => {
      this._onViewportChange({
        ...this.state.viewport,
        longitude: this.state.viewport.longitude,
        latitude: this.state.viewport.latitude,
        zoom: 5,
        transitionInterpolator: new FlyToInterpolator(),
        transitionDuration: 500
    });
    }

    render() {


      const { userLocations, visibleSessions, settings } = this.state

      // console.log(this.state.visibleSessions)
      // if(userLocations.length === 0)
      //   return null // no ready yet

      const viewport = {
        ...this.state.viewport,
        // ...this.props
      };
      return (
        <div>
        <MapGL ref={el => this.mapGL = el} { ...viewport } {...settings} scrollZoom={true} onViewportChange={ this._onViewportChange } mapboxApiAccessToken={MAPBOX_TOKEN} >
          <SVGOverlay redraw={ this._redrawSVGOverlay }/>,

          {this._renderPopup()}
          { visibleSessions.map(this._renderSessionMarker) }
        </MapGL>

        <ZoomButtons zoomIn={this._zoomIn} zoomOut={this._zoomOut} />
        </div>
      );

      // return (
      //   <MapGL { ...viewport } {...settings} scrollZoom={true} onViewportChange={ this._onViewportChange } mapboxApiAccessToken={MAPBOX_TOKEN} >
      //     <SVGOverlay redraw={ this._redrawSVGOverlay }/>,
      //     { userLocations.map(this._renderDrawing) }
      //   </MapGL>
      // );
    }



}

// export default enhance(ContentDetails)

export default Map



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v1/DashboardMap.js